import {
  InstantAnswerBuilderFn,
  InstantAnswerContext,
  InstantAnswerScenario,
} from "@faire/help-center-self-serve/types";
import { StrictLocalizeFunction } from "@faire/web--source/common/localization";

export const FaireDirectWidgetIA: InstantAnswerBuilderFn = (strictLocalize) => {
  return {
    titleBuilder: (context) => {
      return getAnswer(context, strictLocalize).getTitle();
    },

    descriptionBuilder: (context) => {
      return getAnswer(context, strictLocalize).getDescription();
    },
  };
};

const getAnswer = (
  _context: InstantAnswerContext,
  strictLocalize: StrictLocalizeFunction
): InstantAnswerScenario => {
  return {
    getTitle: () => FAIRE_DIRECT_WIDGET_TITLE(strictLocalize),
    getDescription: () => [FAIRE_DIRECT_WIDGET_DESCRIPTION(strictLocalize)],
  };
};

const FAIRE_DIRECT_WIDGET_TITLE = (strictLocalize: StrictLocalizeFunction) =>
  strictLocalize({
    defaultMessage: "Let’s help you install the widget",
    description: {
      text: "Title of answer for installing the Faire Direct widget",
      img: "https://cdn.faire.com/fastly/a6a14152fd5623c230ffba52dff61bbb1683269c5c15f68b6e55798c1d3b275e.png",
    },
  });

const FAIRE_DIRECT_WIDGET_DESCRIPTION = (
  strictLocalize: StrictLocalizeFunction
) =>
  strictLocalize({
    defaultMessage:
      "Our support team will be happy to help. Chat with an agent or check out the related articles below.",
    description: {
      text: "Description of answer for installing the Faire Direct widget",
      img: "https://cdn.faire.com/fastly/a6a14152fd5623c230ffba52dff61bbb1683269c5c15f68b6e55798c1d3b275e.png",
    },
  });
